import { FormDatePicker } from '@Components/Form';
import { Box, Button, Typography } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';

const FormDatePickers = () => {
  const formContext = useForm<{ date: Date | null }>({
    defaultValues: { date: null },
  });

  return (
    <Box>
      <Typography variant="h3">Form DatePicker</Typography>
      <FormProvider {...formContext}>
        <form
          onSubmit={formContext.handleSubmit((values) => {
            console.log('Form Values:', values);
          })}
        >
          <Box display={'flex'} alignItems={'flex-end'} gap={2} mt={2}>
            <FormDatePicker
              name="date"
              label="Date"
              control={formContext.control}
              rules={{ required: 'Date is required' }}
              slotProps={{
                field: { clearable: true },
                toolbar: { hidden: false },
              }}
              localeText={{ toolbarTitle: 'เลือก วัน เดือน ปี' }}
            />
            <Button type="submit">Submit</Button>
          </Box>
        </form>
      </FormProvider>
    </Box>
  );
};

export default FormDatePickers;
